import { render, staticRenderFns } from "./SelectBoxSimple.vue?vue&type=template&id=413255ae&"
import script from "./SelectBoxSimple.vue?vue&type=script&lang=ts&"
export * from "./SelectBoxSimple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports